import { TPA_STREAM_CONNECT_TOKEN_STORAGE_KEY } from 'config/tpaStreamStorageKeys';

/** SEC-LOW-01: connect token stays in memory only (never localStorage). */
let connectTokenInMemory: string | null = null;

function removeLegacyConnectTokenFromLocalStorage(): void {
  if (typeof window === 'undefined' || typeof window.localStorage?.removeItem !== 'function') {
    return;
  }

  try {
    window.localStorage.removeItem(TPA_STREAM_CONNECT_TOKEN_STORAGE_KEY);
  } catch {
    // Ignore storage errors during cleanup.
  }
}

export function setTpaStreamConnectToken(token: string | null): void {
  const trimmed = typeof token === 'string' ? token.trim() : '';
  connectTokenInMemory = trimmed !== '' ? trimmed : null;
  removeLegacyConnectTokenFromLocalStorage();
}

export function getTpaStreamConnectToken(): string | null {
  return connectTokenInMemory;
}

export function clearTpaStreamConnectToken(): void {
  connectTokenInMemory = null;
  removeLegacyConnectTokenFromLocalStorage();
}
